// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppTypePickerController from "./app_type_picker_controller"
application.register("app-type-picker", AppTypePickerController)

import DragController from "./drag_controller"
application.register("drag", DragController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FilterFormController from "./filter_form_controller"
application.register("filter-form", FilterFormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IssueBoardController from "./issue_board_controller"
application.register("issue-board", IssueBoardController)

import LinearTicketController from "./linear_ticket_controller"
application.register("linear-ticket", LinearTicketController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import SimilarIssuesController from "./similar_issues_controller"
application.register("similar-issues", SimilarIssuesController)

import StatusChangeController from "./status_change_controller"
application.register("status-change", StatusChangeController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToastMessageController from "./toast_message_controller"
application.register("toast-message", ToastMessageController)

import WebhookProjectsController from "./webhook_projects_controller"
application.register("webhook-projects", WebhookProjectsController)
